import { AutoMap } from '@automapper/classes';

export class ProcessEntity {
    Id?: number;
    @AutoMap()
    Code!: number;
    @AutoMap()
    Name!: number;
    @AutoMap()
    CustomerReference!: string;
    @AutoMap()
    VentilationGlobale!: number;
    @AutoMap()
    Type!: number;
    @AutoMap()
    DustLevel!: string;
    @AutoMap()
    DustLoadType!: number;
    @AutoMap()
    SubSection!: number;
    @AutoMap()
    Observation!: string;
    @AutoMap()
    VolumeRenouvellementAir?: number;

    MeasureId?: number;
    GlobalTaskIds?: number[];
    ProcessTechniqueIds?: number[];
    ProcessCalculationId?: number;
    MeanOfPreventionIds?: number[];
    AreaMapId?: number;
}
